module.exports = __webpack_public_path__ + "static/media/011.7c8699b6.jpg";